import { render, staticRenderFns } from "./PostChooserInput.vue?vue&type=template&id=0f94fcdd&"
import script from "./PostChooserInput.vue?vue&type=script&lang=ts&"
export * from "./PostChooserInput.vue?vue&type=script&lang=ts&"
import style0 from "./PostChooserInput.vue?vue&type=style&index=0&id=0f94fcdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports